/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { Checkbox, Flex, Menu, UnstyledButton } from '@mantine/core'
import { useQueryClient } from '@tanstack/react-query'

import { Order } from '@/types/actionPlan.types'

import type {
  FilterItems,
  TableFilterProps,
} from '@/modules/actionPlan/pages/components/TableFilter/TableFilter.types'

import { Button } from '@/components/Button/Button'
import { Text } from '@/components/Text/Text'

import { useGoalsServiceGoalsControllerGetAllKey } from '@/__generated__/queries'

import FilterIcon from '@/assets/icons/filter.svg?react'

import classes from './TableFilter.module.css'

export function TableFilter({
  onFilterChange,
  order,
  ...props
}: TableFilterProps) {
  const [opened, setOpened] = useState(false)
  const [localOrder, setLocalOrder] = useState<Order>(order)

  const queryClient = useQueryClient()

  const items: FilterItems[] = [
    { label: 'From newest to oldest', value: Order.NEW_FIRST },
    { label: 'From oldest to newest', value: Order.OLD_FIRST },
    { label: 'By deadline', value: Order.DEADLINE },
  ]

  const handleApplyFilters = () => {
    onFilterChange(localOrder)
    setOpened(false)

    queryClient.invalidateQueries({
      queryKey: [useGoalsServiceGoalsControllerGetAllKey],
    })
  }

  return (
    <Menu
      {...props}
      closeOnItemClick={false}
      onChange={setOpened}
      onOpen={() => setLocalOrder(order)}
      opened={opened}
      position="bottom-end"
      radius={8}
    >
      <Menu.Target>
        <UnstyledButton h={24}>
          <FilterIcon />
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown className={classes.container}>
        <Text variant="body_1">Filter by date</Text>
        <Flex direction="column">
          {items.map(item => (
            <Flex
              key={item.label}
              align="center"
              className={classes.menuItem}
              gap={8}
              onClick={() => setLocalOrder(item.value)}
            >
              <Checkbox
                checked={localOrder === item.value}
                classNames={{ input: classes.checkbox }}
                onChange={() => setLocalOrder(item.value)}
              />
              <Text variant="body_1">{item.label}</Text>
            </Flex>
          ))}
        </Flex>

        <Button
          h={40}
          miw={0}
          mt={16}
          onClick={handleApplyFilters}
          variant="primary"
          w="100%"
        >
          Apply
        </Button>
      </Menu.Dropdown>
    </Menu>
  )
}
